import { useTranslation } from "react-i18next";
import { faWindowMaximize } from "@fortawesome/pro-regular-svg-icons";
import { IWebsiteBuilderNodeMetadata } from "../nodeMetadata/websiteBuilderNodeMetadata";

export function useWebsiteBuilderTabMetadata(): IWebsiteBuilderNodeMetadata {
  const { t } = useTranslation();

  return {
    title: t("Tab"),
    icon: faWindowMaximize,
  };
}
